class AppointmentLocationProvider {
    constructor(beschikbaarheidTypesCache) {
        'ngInject';
        this.availabilitiesCache = beschikbaarheidTypesCache;
        this.locations = [];
    }

    getLocation(practice, availabilityId) {

        if(!availabilityId){
            return practice;
        }

        let cachedLocation = this.locations[availabilityId];
        if (cachedLocation) {
            return cachedLocation;
        }

        const availabilities = this.availabilitiesCache.filter(x => x.id === availabilityId);

        if (availabilities.length === 0) {
            this.locations[availabilityId] = practice;
            return practice;
        }

        const locations = practice.adressen.filter(x => x.id === availabilities[0].praktijk_adres_id);

        if (locations.length === 0) {
            this.locations[availabilityId] = practice;
            return practice;
        }

        this.locations[availabilityId] = locations[0];
        return locations[0];
    }
}

(function () {
    'use strict';
    angular.module('doclr.components.util')
        .service('AppointmentLocationProvider', AppointmentLocationProvider);
})();

